import axios from 'axios';

const API_BASE = import.meta.env.VITE_API_BASE_URL as string;

export interface MeResponse {
  user: Record<string, any> | null;
}

export default class AuthApiService {
  /** Fetch the current authenticated user */
  static async fetchMe(): Promise<MeResponse> {
    const url = `${API_BASE}/auth/me`;
    const response = await axios.get<MeResponse>(url, { withCredentials: true });
    return response.data;
  }

  static async logout(): Promise<void> {
    const url = `${API_BASE}/auth/logout`;
    await axios.post(url, {}, { withCredentials: true });
  }

  static async login(): Promise<void> {
    const url = `${API_BASE}/auth/login`;
    window.location.href = url;
  }
}
